import axios from 'axios';
import React, { useState } from 'react';
import { Modal, Form, Button } from 'react-bootstrap';

const Valid8CSVModal = ({ show, setShow, reload }) => {
  const [headers, setHeaders] = useState([]);
  const [emailColumn, setEmailColumn] = useState('');
  const [file, setFile] = useState(null);

  const handleClose = () => setShow(false);

  const handleFileUpload = e => {
    setEmailColumn('');
    setHeaders([]);
    setFile(null);
    const file = e.target.files[0];
    if (!file) return;
    setFile(file);

    const reader = new FileReader();
    reader.onload = e => {
      const text = e.target.result;
      const headers = text
        .split('\n')[0]
        .split(',')
        .map(h => h.trim());
      setHeaders(headers);
    };
    reader.readAsText(file);
  };

  const uploadFile = async () => {
    const formData = new FormData();
    formData.append('emailColumn', emailColumn);
    formData.append('file', file);

    try {
      await axios.post('/pmladmin/valid8-csvs/upload', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
    } catch (err) {
      console.error(err);
      alert('Failed to upload CSV');
    }

    if (reload) reload();
    handleClose();
  };

  return (
    <Modal show={show} onHide={handleClose} centered size="xl">
      <Modal.Header closeButton>
        <Modal.Title>Upload CSV</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form.Group className="mb-3">
          <Form.Label>CSV</Form.Label>
          <Form.Control type="file" onChange={handleFileUpload} />
        </Form.Group>
        <Form.Group className="mb-3">
          <Form.Label>Email Column</Form.Label>
          <Form.Select
            aria-label="Email Column"
            disabled={headers.length == 0}
            onChange={e => setEmailColumn(e.target.value)}
          >
            <option value="">Select column</option>
            {headers.map((header, i) => (
              <option key={i} value={header}>
                {header}
              </option>
            ))}
          </Form.Select>
        </Form.Group>
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="danger"
          onClick={uploadFile}
          disabled={emailColumn == ''}
        >
          Upload
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default Valid8CSVModal;
